export default __webpack_public_path__ + "static/media/follow-market.14918434.webp";